import { useMutation as c } from "@apollo/client";
import { accountSchema as m } from "../../deserialize/yup/account.js";
import p from "../../graphql/client/loginClient.js";
import { deserializeData as s } from "../../graphql/deserialize/index.js";
import l from "../../graphql/mutation/loginByOAuth.js";
import { useCallback as f } from "react";
const k = () => {
  const [t, { loading: o }] = c(l, {
    client: p
  });
  return { loginByOAuth: f(
    async (r, n, i, a, e) => {
      const u = await t({
        variables: {
          input: {
            oauthAppType: r,
            network: n,
            isLogin: !0,
            providerInput: {
              authCode: a,
              redirectURI: i
            },
            invitationCode: e
          }
        }
      });
      return s(u, m);
    },
    []
  ), loading: o };
};
export {
  k as default
};
//# sourceMappingURL=useLoginByOAuth.js.map
